"use strict";

export const formScripts = () =>{
    const forms= document.querySelectorAll('.leioc-entry-form');

    forms.forEach( fm=> {
        fm.noValidate = true;

        //Validates form
        fm.onsubmit = e =>{
            e.preventDefault();
            //Validate Entry form before submit
            if( validate(fm) ) formSubmit(fm);
        }

        //Resets Error messages on change
        fm.onchange = () => removeMsgs(fm);
        fm.onclick = () => removeMsgs(fm);

        const isHidden = elem => {
            const styles = window.getComputedStyle(elem)
            return styles.display === 'none' || styles.visibility === 'hidden'
        }

        const validate = form => {
            form.querySelector('button[type="submit"]').classList.remove('error');
            form.querySelector('.js-form-error').classList.remove('show');
            form.querySelectorAll('.field-msg.error').forEach( f => f.classList.remove('show') );
    
            let data = new FormData(form),
                check = true;
    
            //Loops through form data
            for(const pair of data.entries() ){
                let elem = form.querySelector(`[name="${pair[0]}"]`),
                      val = elem.value,
                      err = elem.closest('div').querySelector('.field-msg.error'),
                      pattern = true;
    
                //Skips hidden inputs
                if( isHidden(elem) ) return true;
    
                //Skips validation if not required
                if( !elem.hasAttribute('required') ) return true;
    
                //Sets value to blank for options inputs
                if( val.match(/-- select/gi) ) val = '';
    
                //Checks input pattern matches
                if( elem.hasAttribute('pattern') ){
                    let regex = new RegExp( elem.getAttribute('pattern'), 'gi' );
                    pattern = regex.test( String(val).toLowerCase() );
                }
    
                if( !val || pattern === false){
    
                    if(err) {
                        err.classList.add('show');

                        //Only if Modal present
                        form.querySelectorAll('section').forEach( e => e.classList.remove('show') );
                        const currentSection = elem.closest('section');
                        currentSection.classList.add('show');
                        modalButtonsShow( form.closest('.leioc-modal-paypal') );
                    }
    
                    //Changes Submit button to red
                    form.querySelector('button[type="submit"]').classList.add('error');
                    form.querySelector('.js-form-error').classList.add('show');
    
                    check = false;
                    return false;
                }
            }
    
            return check;
        }

        //Submits form after validation
        const formSubmit = async form => {
            const url = form.dataset.url;
            const eventId = form.querySelector('[name="event_id"]').value;
            let data = new FormData(form);

            //Resets error message to default
            form.querySelectorAll('.js-form-error').forEach( f => f.innerText = 'There was a problem with the Entry Form, please try again!');
    
            //Set form messages
            form.querySelectorAll('.field-msg').forEach( f => f.classList.remove('show') );
            form.querySelectorAll('.js-form-submission').forEach(f => f.classList.add('show') );

            form.querySelector('button[type="submit"]').disabled = true;
    
            try{
                const response = await fetch( url, {
                    method: 'POST',
                    body: data
                });

                const result = await response.json();

                form.querySelectorAll('.field-msg').forEach( f => f.classList.remove('show') );
                form.querySelector('button[type="submit"]').disabled = false;

                if( response.ok ){
                    form.reset();
                    //Rebuild start times
                    if( result.start){
                        document.querySelectorAll('.leioc-form-start').forEach( s => s.innerHTML = result.start);
                    }
                    
                    //Refresh entries table
                    const table =  document.getElementById(`leioc-${eventId}`);
                    if( table ){
                        if(result.table) table.innerHTML = result.table;
                        if(result.count) table.closest('.leioc-shortcode-table-wrapper').querySelector('.leioc-count').innerText = `Number of entries (${result.count})`;
                    }

                    form.querySelectorAll('.js-form-success').forEach(f => f.classList.add('show') );
                } else {
                    const data = result.data[0];
                    if('error-max' == data.code || 'error-time' == data.code ){
                        form.querySelectorAll('.js-form-error').forEach(f => {
                            f.innerText = data.message;
                            f.classList.add('show');
                        });
                    } else {
                        form.querySelectorAll('.js-form-error').forEach(f => f.classList.add('show') );
                    }
                }
            } catch(error){
                console.log(error);
                form.querySelectorAll('.field-msg').forEach( f => f.classList.remove('show') );
                form.querySelectorAll('.js-form-error').forEach(f => f.classList.add('show') );
                form.querySelector('button[type="submit"]').disabled = false;
            }
        }
    });
}

export const modal = () =>{

    const toggleModal = (id, show = true) => {
        const classList = document.getElementById(id).classList;
        classList.remove( show ? 'fade' : 'visible');
        classList.add( show ? 'visible' : 'fade' );
    }
    //Opens Modal
    document.querySelector('button.leioc-modal-open').onclick = e =>{
        const id = e.target.dataset.url;
        toggleModal(id);
        //resets form to first section on open
        const modal = document.getElementById(id);
        modal.querySelectorAll('section').forEach( s => s.classList.remove('show' ) );
        modal.querySelector('section').classList.add('show');
        removeMsgs(modal);
        modalButtonsShow(modal);
    }
    //Closes Modal
    document.querySelector('.leioc-close').onclick = e =>{
        const id = e.target.closest('div.visible').id;
        toggleModal(id, false);
    }

    document.querySelectorAll('.leioc-modal-paypal').forEach( modal => {
        //Sets next button
        modal.querySelector('button.leioc-btn.nxt').onclick = () => {
            slide(1);
        }
        //Sets previous button
        modal.querySelector('button.leioc-btn.prev').onclick = () => {
            slide(-1);
        }
        //Sets Section to correct view
        const slide = i => {
            const currentSection = modal.querySelector('section.show');
            const nxt = currentSection.nextElementSibling;
            const prev = currentSection.previousElementSibling;
            const section = (i == 1 ? nxt : prev);

            if( section != null ){
                currentSection.classList.remove('show');
                section.classList.add('show');
            }
            modalButtonsShow(modal);
        }
    })
}

const modalButtonsShow = modal => {
    const currentSection = modal.querySelector('section.show');
    const nxt = currentSection.nextElementSibling;
    const prev = currentSection.previousElementSibling;

    if( nxt != null && prev != null){
        modal.querySelector('.leioc-btn.prev').classList.add('show');
        modal.querySelector('.leioc-btn.nxt').classList.add('show');
        modal.querySelector('.leioc-btn.success').classList.remove('show');
    } else {
        if( nxt == null) {
            modal.querySelector('.leioc-btn.success').classList.add('show');
            modal.querySelector('.leioc-btn.nxt').classList.remove('show');
            modal.querySelector('.leioc-btn.success').classList.add('show');
        } else {
            modal.querySelector('.leioc-btn.prev').classList.remove('show');
            modal.querySelector('.leioc-btn.nxt').classList.add('show');
            modal.querySelector('.leioc-btn.success').classList.remove('show');
        };
    }
}

const removeMsgs = fm =>{
    fm.querySelector('button[type="submit"]').classList.remove('error');
    fm.querySelector('.js-form-error').classList.remove('show');
    fm.querySelectorAll('.field-msg').forEach( f => f.classList.remove('show') );
}